// extracted by mini-css-extract-plugin
export default {"home":"Home_home__Iy41P","img":"Home_img__EDVsv","title":"Home_title__XLxL1","job":"Home_job__w1iPS","subTitle":"Home_subTitle__W6kq-","skills":"Home_skills__yXM80"};